import { lazy } from 'react';
import { ONBOARDING_PERMISSIONS } from './constants';

const OnboardingQueuePage = lazy(() => import('./pages/OnboardingQueuePage'));

export const onboardingRoutes = [
  {
    path: '/onboarding',
    element: OnboardingQueuePage,
    permission: ONBOARDING_PERMISSIONS.APPROVE,
    nav: { labelKey: 'nav.onboarding', icon: 'TeamOutlined', group: 'orgMgmt' },
  },
];
